import type {App, Directive, DirectiveBinding} from 'vue';
// 拖拽的指令
const dragDirective: Directive = {
  beforeMount(el: any, binding: DirectiveBinding) {
    if (binding.value) {
      el.style.userSelect = 'none';
      el.style.left = '0px';
      el.style.top = '0px';
      el.onmousedown = (e) => {
        let eParent = el.parentNode;
        let ePWidth = eParent.offsetWidth;
        let ePHeight = eParent.offsetHeight;
        let eWidth = el.offsetWidth;
        let eHeight = el.offsetHeight;
        let disX = e.clientX - el.offsetLeft;
        let disY = e.clientY - el.offsetTop;
        // console.log(eParent.style.position);
        document.onmousemove = (e) => {
          let left = e.clientX - disX;
          let top = e.clientY - disY;
          if (left > 0) {
            if (ePWidth - left > eWidth) {
              el.style.left = left + 'px';
            } else {
              el.style.left = ePWidth - eWidth + 'px';
            }

          } else {
            el.style.left = 0;
          }
          if (top > 0) {
            if (ePHeight - top > eHeight) {
              el.style.top = top + 'px';
            } else {
              el.style.top = ePHeight - eHeight + 'px';
            }
          }

        };
        document.onmouseup = (e) => {
          document.onmousemove = null;
          document.onmouseup = null;
        };
        return false;
      };
    }
  }
}

export function setupDragDirective(app: App) {
  app.directive('drag', dragDirective);
}
